import { customAttribute, INode, PLATFORM } from 'aurelia';

@customAttribute('fix-scroll')
export class FixScroll {
    private sticky;
    private sticky1;
    private stickyOffset;
    private sticky1Offset;

    constructor(
        @INode readonly element: HTMLElement
    ) {}

    attached() {
        this.sticky = document.getElementById('form-summary');
        this.sticky1 = document.getElementById('form-help');

        throttle('scroll', 'scroll.throttled', this.element as any);
        throttle('resize', 'resize.throttled', this.element as any);

        this.stickyOffset;
        this.sticky1Offset;

        this.init();

        this.element.addEventListener('scroll.throttled', this.scrollEvent);
        this.element.addEventListener('resize.throttled', this.resizeEvent);
    }

    detached() {
        this.element.removeEventListener('scroll.throttled', this.scrollEvent);
        this.element.removeEventListener('resize.throttled', this.resizeEvent);
    }

    resizeEvent = () => {
        this.init();
    };

    scrollEvent = () => {
        const scrollContainerTop = this.element.scrollTop;

        if (!this.sticky) {
            this.sticky = document.getElementById('form-summary');
            this.sticky1 = document.getElementById('form-help');
        }

        if (!this.sticky) {
            return;
        }

        if (scrollContainerTop > this.stickyOffset) {
            this.sticky.classList.add('active');
        } else {
            this.sticky.classList.remove('active');
        }

        if (scrollContainerTop > this.sticky1Offset) {
            this.sticky1.classList.add('active');
        } else {
            this.sticky1.classList.remove('active');
        }
    };

    init() {
        if (window.innerWidth > 980) {
            this.stickyOffset = 80;
            this.sticky1Offset = 90;
        } else {
            this.stickyOffset = 205;
            this.sticky1Offset = 205;
        }
    }
}

function throttle(type, name, obj = window) {
    let running = false;

    const callback = function () {
        if (running) {
            return;
        }

        running = true;

        requestAnimationFrame(function () {
            obj.dispatchEvent(new CustomEvent(name));
            running = false;
        });
    };

    obj.addEventListener(type, callback);
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = FixScroll;

    // @ts-ignore
    const proto = FixScroll.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }